import React from 'react';
import {IconButton, Typography} from '@material-ui/core';
import {useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import MaterialTable from 'material-table';
import TableIcons from '../utils/TableIcons';
import RefreshIcon from '@material-ui/icons/Refresh';
import LaunchIcon from '@material-ui/icons/Launch';
import {navigate} from '@reach/router';
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import theme from "../styles/theme";
import ReportIcon from "@material-ui/icons/Report";

const CampaignCapacities = () => {
    const {loading, data, refetch} = useQuery(gql`
        query CampaignCapacities {
            allCampaign(
                filter: {
                    hasCapacity: true
                }
            ) {
                totalCount
                nodes {
                    id
                    capacities {
                        id
                        name
                        resetFrequency
                        limit
                        usage
                        limitExceeded
                        constraints {
                            field
                            values
                        }
                    }
                }
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
    });

    const campaigns = data && data.allCampaign && data.allCampaign.nodes

    return (
        <>
            <Typography variant="h2">
                Campaign Capacities
            </Typography>

            {!loading && campaigns ? (
                <MaterialTable
                    title=""
                    icons={TableIcons}
                    columns={[
                        {title: "Campaign ID", field: "campaign_id"},
                        {title: "Status", field: "status"},
                        {title: "Limit", field: "limit"},
                        {title: "Usage", field: "usage"},
                        {title: "Reset Frequency", field: "reset_frequency"},
                        {title: "ID", field: "id"},
                    ]}
                    data={campaigns.flatMap(campaign => campaign.capacities.flatMap(capacity => ({
                        campaign_id: campaign.id,
                        id: capacity.id,
                        limit: capacity.limit,
                        usage: capacity.usage,
                        reset_frequency: capacity.resetFrequency,
                        status: capacity.limitExceeded ? (
                            <ReportIcon fontSize="large" style={{color: theme.palette.error.main}}/>
                        ) : (
                            <PlayArrowIcon fontSize="large" style={{color: theme.palette.success.main}}/>
                        )
                    })))}
                    actions={[
                        {
                            icon: () => <RefreshIcon/>,
                            tooltip: 'Refetch Data',
                            isFreeAction: true,
                            onClick: () => refetch()
                        },
                        {
                            icon: () => <LaunchIcon/>,
                            tooltip: 'View Campaign',
                            onClick: () => {
                                return null;
                            },
                        },
                    ]}
                    options={{
                        pageSize: data.allCampaign.totalCount,
                    }}
                    components={{
                        Action: props => {
                            const {action, data} = props;
                            const {tooltip} = action;
                            if (tooltip === 'View Campaign') {
                                return (
                                    <div style={{cursor: 'context-menu'}}>
                                        <LaunchIcon onClick={() => navigate(`/info/campaigns/${data.campaign_id}`)}/>
                                    </div>
                                );
                            }

                            return (
                                <IconButton onClick={() => action.onClick()}>
                                    {action.icon()}
                                </IconButton>
                            );
                        }
                    }}
                    style={{whiteSpace: "nowrap"}}
                />
            ) : null}
        </>
    )
};

export default CampaignCapacities
